import { render } from "./PrioridadTicketComponent.vue?vue&type=template&id=614e6f35"
import script from "./PrioridadTicketComponent.vue?vue&type=script&lang=js"
export * from "./PrioridadTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__